import React, { useState, useEffect, useRef} from 'react';
import html2canvas from 'html2canvas';
import Swal from 'sweetalert2';
import { Row, Col, Button } from "react-bootstrap";
import { useProvider } from '../../context/MenuProvider';

const QuoteCard = () => {
  const { 
    crud, 
    site, 
    userAdmin,
    buscarDadosPorId,
    salvarDados,
  } = useProvider();
  const { post, get } = crud || {};
  const divRef = useRef();
  const [frase, setFrase] = useState(null);
  const [autor, setAutor] = useState(null);
  const [frases, setFrases] = useState([]);
  const [semAutor, setSemAutor] = useState(false);
  const [mais, setMais] = useState(false);
  
  const temas = [
    // Empreendedorismo
    'Ação',
    'Coragem',
    'Mentalidade Empreendedora',
    'Persistência',
    'Disciplina',
    'Inovação',
    'Liderança',
    'Networking',
    'Resultados',
    'Visão de Futuro',
  
    // Desenvolvimento Pessoal
    'Autoconhecimento',
    'Autodisciplina',
    'Gratidão',
    'Inteligência Emocional',
    'Mindfulness',
    'Fé',
    'Superação',
    'Atitude Positiva',
    'Motivação Diária',
    'Propósito de Vida',
  
    // Saúde e Bem-estar
    'Saúde Mental',
    'Equilíbrio Emocional',
    'Qualidade de Vida',
    'Bem-estar Físico',
    'Autocuidado',
    'Alimentação Saudável',
    'Exercício Físico',
    'Hábito Saudáveis',
    'Recuperação Mental',
    'Descanso e Sono',
  
    // Relacionamentos
    'Empatia',
    'Comunicação Eficaz',
    'Amizade Verdadeira',
    'Relacionamentos Saudáveis',
    'Conexões Profundas',
    'Inteligência Social',
    'Respeito Mútuo',
    'Compromisso',
    'Apoio Familiar',
    'Construção de Confiança',
  
    // Finanças e Prosperidade
    'Gestão Financeira',
    'Investimentos Inteligentes',
    'Mentalidade de Riqueza',
    'Independência Financeira',
    'Empoderamento Financeiro',
    'Proatividade Financeira',
    'Segurança Financeira',
    'Poupança Inteligente',
    'Liberdade Financeira',
    'Planejamento Financeiro'
  ];
  const personalidades = [
    // Autores e empreendedores internacionais
    "T. Harv Eker", "Napoleon Hill", "Robert Kiyosaki", "Tony Robbins", "Jim Rohn",
    "Grant Cardone", "Peter Drucker", "Simon Sinek", "Elon Musk", "Jeff Bezos",
    "Steve Jobs", "Warren Buffett", "Mark Zuckerberg", "Richard Branson", "Jack Ma",
    "Oprah Winfrey", "Gary Vaynerchuk", "Tim Ferriss", "Brian Tracy", "Dale Carnegie",
    "Stephen Covey", "Ray Dalio", "Howard Schultz", "Daymond John", "Barbara Corcoran",
    "Kevin O'Leary", "Reed Hastings", "Daniel Goleman", "Robin Sharma", "Mel Robbins",
    "Zig Ziglar", "Les Brown", "Brené Brown", "Chris Gardner", "Suze Orman",
    "Eckhart Tolle", "John Maxwell", "Deepak Chopra", "Donald Trump", "Bill Gates",
    "Larry Page", "Sergey Brin", "Phil Knight", "Sam Walton", "Andrew Carnegie",
    "Henry Ford", "Thomas Edison", "Michael Bloomberg", "Charlie Munger", "Patrick Bet-David",
  
    // Autores e empreendedores brasileiros
    "Paulo Vieira", "Flávio Augusto", "Thiago Nigro", "Bruno Perini", "Joel Jota",
    "Erico Rocha", "Natália Arcuri", "Carlos Wizard", "Bel Pesce", "Lair Ribeiro",
    "Caio Carneiro", "Pedro Sobral", "Leandro Aguiari", "Rick Chesther", "Janguiê Diniz",
    "Gustavo Cerbasi", "Roberto Justus", "Silvio Santos", "Luiza Helena Trajano", "Abílio Diniz",
    "Alfredo Soares", "Eduardo Lyra", "Cristiano Chaves", "Jovem Nerd", "Mário Vergara",
    "Bruno Gimenes", "José Roberto Marques", "Eduardo Moreira", "André Diamand", "Rafael Seabra",
    "Conrado Adolpho", "Wilton Mingotti", "William Sanches", "Allan Dias Castro", "Felipe Tito",
    "Érico Borgo", "Marcos Marques", "Leandro Karnal", "Tiago Brunet", "Davi Braga",
    "Luiz Barsi", "Priscila Zillo", "Marc Tawil", "Geraldo Rufino", "Gisele Bündchen",
    "Rodrigo Cardoso", "Felipe Miranda", "Samuel Pereira", "Roberto Shinyashiki", "Murilo Gun",
  
    // Atletas inspiradores
    "Cristiano Ronaldo", "Lionel Messi", "Michael Jordan", "Kobe Bryant", "LeBron James",
    "Usain Bolt", "Serena Williams", "Simone Biles", "Lewis Hamilton", "Tom Brady",
    "Neymar Jr.", "Pelé", "Ayrton Senna", "Rafa Nadal", "Novak Djokovic",
    "Roger Federer", "Mike Tyson", "Anderson Silva", "Gabriel Medina", "Guga Kuerten"
  ];
  
  const gerarFraseIa = async () => {
    try {
      const tema = temas[Math.floor(Math.random() * temas.length)];
      const autor = personalidades[Math.floor(Math.random() * personalidades.length)];
      
      const prompts = [
        {
          contexto: `Gere uma frase motivacional para empreendedores com foco em "${tema}".`,
          instrucoes: `${
            frases ? `Evite repetir frases já utilizadas: ${JSON.stringify(frases.join(' | '))}. ` : ""
          }A frase deve ser original, curta, clara, impactante e inspirar ação. Retorne no formato JSON: {"mensagem": "", "autor": ""}. 
          O campo "mensagem" deve conter apenas a frase, sem mencionar o autor. 
          O campo "autor" deve conter apenas o nome do autor da frase. 
          Dê preferência a autores e empreendedores renomados como T. Harv Eker, Napoleon Hill, Jim Rohn, Tony Robbins, Robert Kiyosaki, Elon Musk, Jeff Bezos, Steve Jobs, Warren Buffett, entre outros. 
          Também são aceitos autores relevantes fora dessa lista, desde que tenham impacto comprovado em mentalidade, sucesso ou empreendedorismo.`
        },
        {
          contexto: `Gere uma frase motivacional do autor "${autor}".`,
          instrucoes: `${
            frases ? `Evite repetir frases já utilizadas: ${JSON.stringify(frases.join(' | '))}. ` : ""
          }A frase deve ser original, curta, clara, impactante e inspirar ação. Retorne no formato JSON: {"mensagem": "", "autor": ""}. 
          O campo "mensagem" deve conter apenas a frase, sem mencionar o autor. 
          O campo "autor" deve conter apenas o nome do autor da frase.`
        },
      ];
      
      const formData = prompts[Math.floor(Math.random() * prompts.length)];
  
      const response = await post(formData, `/assistente-ia/openai-chat/gerar-mensagem/`, null, 'frase');
      
      if (response && response.length) {
          const novaFrase = response?.[0]?.response;
          
          setAutor(novaFrase.autor ||``);
          setFrase(novaFrase.mensagem);
          setFrases([...frases, novaFrase?.mensagem]);
          
          await updateDados({
            mensagem:novaFrase?.mensagem, 
            autor:novaFrase?.autor, 
            frases_anteriores:[...frases, novaFrase?.mensagem]
          });
      }
    } catch (err) {
      //alert(JSON.stringify(err.response))
      console.error("Erro ao gerar frase:", err);
    }
  };
  
  
  const carregarFraseDoDia = async () => {
    try {
      const response = await buscarDadosPorId('local_registros','frase_do_dia');
      const hoje = new Date().toLocaleDateString('sv-SE');
  
      if (response) {
        const { data, autor, mensagem, frases_anteriores } = response;
  
        if (data === hoje) {
          setAutor(autor);
          setFrase(mensagem);
          setFrases(frases_anteriores?.slice(-10)||[]);
          return true;
        }
      }
    } catch (err) {
      console.error("Erro ao carregar a frase_do_dia:", err);
    }
  };
  const gravarFraseDoDia = async ({mensagem, autor, frases_anteriores}) => {
    try {
      setFrases(prevFrases => [...prevFrases?.slice(-10), mensagem]);
      setFrase(mensagem);
      setAutor(autor);
      
      const frase_do_dia = {
        mensagem,
        autor, 
        frases_anteriores,
        data:new Date().toLocaleDateString('sv-SE'),
      }
      await salvarDados('local_registros',{
        ...frase_do_dia,
        id:'frase_do_dia'
      });
    } catch (err) {
      //alert(JSON.stringify(err))
      console.error("Erro ao carregar a frase_do_dia:", err);
    }
  };
  
  const buscarFraseDoDia = async ()=>{
    try{
      const response = await get(`/rede/frases-do-dia/`,'frase');
      if(response && response.length){
        const { data, autor, mensagem, frases_anteriores } = response[0];
        setAutor(autor);
        setFrase(mensagem);
        setFrases(frases_anteriores?.slice(-10)||[]);
        await updateDados({
          mensagem:response[0].mensagem, 
          autor:response[0].autor, 
          frases_anteriores:[],
        });
      }
    }catch(err){
      
    }
  }
  
  const updateDados = async (data) => {
      try {
        var atualizado = {
          ...data,
          data:new Date().toLocaleDateString('sv-SE'),
          id:"frase_do_dia",
        }
        await salvarDados('local_registros', atualizado);
      } catch (err) {
        console.error(err);
      }
  };
  const carregarLocal = async()=>{
      const hoje = new Date().toLocaleDateString('sv-SE');
      let data;
      try{
        const response = await buscarDadosPorId('local_registros', "frase_do_dia");
        if(response && response.data === hoje){
          const base = response;
          data = base.data;
          setAutor(base.autor);
          setFrase(base.mensagem);
          setFrases(base.frases_anteriores?.slice(-10)||[]);
        }
      }catch(err){
        
      }finally{
        if (hoje != data)
        buscarFraseDoDia();
      }
  }
  
  useEffect(()=>{
    // const carregarAutor = async()=>{
    //   let result = await carregarSite();
    //   result = result?.empresa?.nome_da_loja||result?.nome_curto;
    //   if (!result){
    //     result = (await carregarEmpresa())?.nome_da_loja;
    //   }
    //   setSemAutor(result);
    //   if (!(await carregarFraseDoDia())){
    //     await buscarFraseDoDia();
    //   }
    // }
    //carregarAutor();
    carregarLocal();
  },[])
  
  useEffect(() => {
    if ((autor||``).toLowerCase().includes("desconhecido")) {
      setAutor(semAutor);
    }
  }, [autor]);
  
  const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      }
  });
  
  const captureAndShareScreenshot = ({url, text, title}) => {
    html2canvas(divRef.current, {
      useCORS: true, // Habilita o CORS para carregar imagens externas
      allowTaint: true, // Permite capturar imagens externas com problemas de CORS
      scale:4,
    }).then((canvas) => {
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], 'screenshot.png', { type: 'image/png' });
  
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({
              title: title || 'Screenshot',
              text: text || 'Veja minha captura de tela!',
              files: [file],
              //url: url||`/catalogo/${venda?.cliente?.empresa?.url}/?p=meus-pedidos&t=${venda?.cliente?.token}&i=${venda?.id}`,
            })
            .then(() => {
              console.log('Imagem compartilhada com sucesso!')
              Toast.fire({
                  icon: "sucesso",
                  title: "Imagem compartilhada com sucesso!"
              });
            })
            .catch((error) => {
              console.error('Erro ao compartilhar:', error);
              Toast.fire({
                  icon: "error",
                  title: "Erro ao compartilhar imagem!"
              });
            });
          } else {
            console.log('Compartilhamento não é suportado no seu navegador.');
          }
        }
      }, 'image/png');
    });
  };
  
  const captureScreenshot = ({ nome }) => {
    html2canvas(divRef.current, {
      useCORS: true, // Habilita o CORS para carregar imagens externas
      allowTaint: true, // Permite capturar imagens externas com problemas de CORS
      scale:4,
    }).then((canvas) => {
      const image = canvas.toDataURL('image/png');
      console.log(image);
      const link = document.createElement('a');
      link.href = image;
      link.download = `${nome || 'screenshot'}.png`;
      link.click();
    });
  };
  
  const captureCopy = () => {
    html2canvas(divRef.current, {
      useCORS: true, // Habilita o CORS para carregar imagens externas
      allowTaint: true, // Permite capturar imagens externas com problemas de CORS
      scale:4,
    }).then((canvas) => {
      const image = canvas.toDataURL('image/png');
      console.log(image);
  
      // Copiar a imagem para a área de transferência
      canvas.toBlob((blob) => {
        const item = new ClipboardItem({ 'image/png': blob });
        navigator.clipboard.write([item]).then(() => {
          console.log('Imagem copiada para a área de transferência!');
          Toast.fire({
              icon: "success",
              title: "Imagem copiada para área de transferência"
          });
        }).catch((err) => {
          //alert(err)
          Toast.fire({
              icon: "error",
              title: "Erro ao copiar para a área de transferência"
          });
          console.error('Erro ao copiar para a área de transferência:', err);
        });
      });
      
    });
  };
  
  
  return (<>
        <div onClick={()=>setMais(!mais)} className="d-flex justify-content-center">
          <i ref={divRef}>
            <QuoteBaseCard
              mais={mais}
              frase={frase}
              autor={autor}
            />
          </i>
        </div>

        {mais && (<>
          <div className="mt-2 d-flex justify-content-center fs-1">
              <i onClick={captureAndShareScreenshot} className="m-2 bx bx-share-alt"></i>
              <i onClick={captureScreenshot} className="m-2 bx bx-cloud-download"></i>
              <i onClick={captureCopy} className="m-2 bx bx-copy-alt"></i>
              <i onClick={gerarFraseIa} className="m-2 bx bx-refresh"></i>
              <i onClick={buscarFraseDoDia} className="m-2 bx bx-sun"></i>
          </div>
        </>)}
  </>)
}

const QuoteBaseCard = ({ frase, autor, mais=true }) => {
  return (
    <>
      {!mais && (
        <>
          <Button variant="outline-secondary" className="text-center w-100" style={{
                fontFamily: 'Merienda, cursive',
                fontSize: '14px',
              }}>
                {frase}
          </Button>
        </>
      )}
      {mais && (
        <>
          <div style={{
            padding: '10px',
            maxWidth: '450px',
            minWidth: '350px',
            paddingBottom: '15px',
            backgroundColor: 'black',
          }}>
            <div style={{
              border: '2px solid white',
              borderRadius: '15px',
              padding: '20px',
              paddingBottom: '30px',
              minHeight: '250px',
              backgroundColor: 'black',
              color: 'white',
              fontFamily: 'Arial, sans-serif',
              fontSize: '24px',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
            }}>
              <p style={{
                margin: 0,
                fontSize: '24px',
              }}>
                {frase}
              </p>
              <p style={{
                position: 'absolute',
                bottom: '-28px',
                backgroundColor: 'black',
                color: 'white', // importante para contraste
                textAlign: 'center',
                padding: '0 10px',
                fontFamily: 'Merienda, cursive',
                fontSize: '12px',
                letterSpacing: '2px'
              }}>
                {autor}
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default QuoteCard;